import { MouseEvent } from "react";
import { Box, Typography } from "@mui/material";
import { Avatar } from "@benefit-systems/hr-tools-ui";
import { NodeProps } from "@xyflow/react";
import { useFormContext } from "react-hook-form";
import OrgchartAsManagerIcon from "src/Pages/Company/OrganizationStructure/assets/icons/DefaultOrgchartManagerIcon.svg";
import { TEmployeeNode } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Nodes/customNodes.models";
import TopHandle from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Nodes/shared-components/TopHandle";
import useOrgchartEmployeesStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/store";
import useSearchedNodesStyles from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/hooks/useSearchedNodesStyles";
import BottomHandle from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/handles/BottomHandle";

const EmployeeRootNode = ({ data, id: nodeId }: NodeProps<TEmployeeNode>) => {
  const searchedStyles = useSearchedNodesStyles(nodeId);
  const { resetField } = useFormContext();

  const stopPropagation = (event: MouseEvent) => {
    event.stopPropagation();
    resetField("autocomplete", { defaultValue: "" });
    useOrgchartEmployeesStore.getState().setSearchedNodeId(null);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={stopPropagation}
      onKeyDown={(e) => {
        if (e.key === "Enter") stopPropagation(e as unknown as MouseEvent);
      }}
      style={{ opacity: searchedStyles.opacity }}
    >
      <TopHandle />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "24px",
          borderRadius: "12px",
          width: "340px",
          minWidth: "340px",
          maxWidth: "340px",
          padding: "16px 16px 24px 16px",
          border: searchedStyles.border,
          background: "white",
        }}
      >
        <Box>
          {data.avatar ? (
            <Avatar size={13} src={data.avatar}>
              {data.initials || ""}
            </Avatar>
          ) : (
            <Box
              sx={{
                height: "52px",
                width: "52px",
                backgroundColor: "#bdbdbd",
                borderRadius: "100%",
                padding: "6px",
              }}
            >
              <img
                style={{ maxWidth: "100%" }}
                src={OrgchartAsManagerIcon}
                alt="ManagerDefaultIcon"
              />
            </Box>
          )}
        </Box>
        <Typography
          color="textPrimary"
          variant="subtitle2"
          sx={{
            fontWeight: "fontWeightMedium",
            textAlign: "center",
            color: "text.primary",
          }}
        >
          {data.name}
        </Typography>
      </div>
      {(data.isSupervisor || data.hasChildren) && (
        <BottomHandle nodeId={nodeId} />
      )}
    </div>
  );
};

export default EmployeeRootNode;
